// extracted by mini-css-extract-plugin
export var form = "_eo-0";